// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"w7-z"};